export class ChangePasswordRequest {
  login: string;
  oldPassword: string;
  newPassword: string;
  newPasswordConfirmed: string;
}
